import type { ConsentConfiguration } from '@maestro/commerce-blocks/theme/theme.types'
import type { Consent } from '@maestro/data-layer'

import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'

export function createVippsRegisterFormSchema(
  consents: (Consent & ConsentConfiguration)[],
  consentConfigurations: ConsentConfiguration[]
) {
  const consentsSchema = z.object(
    consents.reduce(
      (acc, consent) => {
        const config = consentConfigurations.find((c) => c.id === consent.id)
        if (config?.isRequired) {
          acc[consent.id] = z.boolean().refine((val) => val === true, {
            message: m(`${consent.id}.required`),
          })
        } else {
          acc[consent.id] = z.boolean().optional()
        }
        return acc
      },
      {} as Record<string, z.ZodType>
    )
  )

  return z.object({
    referralCode: z.string().optional(),
    consents: consentsSchema,
  })
}

export type VippsRegisterFormSchema = ReturnType<
  typeof createVippsRegisterFormSchema
>
